import React, { useEffect, useState } from "react";

const POOL = Array.from({ length: 10 }, (_, i) => `/people/p${i}.jpg`);
const META = [
  ["🇳🇬", "Lagos"], ["🇯🇵", "Osaka"], ["🇮🇳", "Mumbai"], ["🇩🇪", "Berlin"], ["🇲🇽", "CDMX"],
  ["🇦🇪", "Dubai"], ["🇦🇺", "Sydney"], ["🇰🇷", "Seoul"], ["🇬🇭", "Accra"], ["🇸🇪", "Malmö"],
];
const shown = [0, 1, 2, 3];

function nextFor(slot) {
  let n = shown[slot];
  do { n = (n + 1 + Math.floor(Math.random() * 3)) % POOL.length; } while (shown.includes(n));
  shown[slot] = n;
  return n;
}

function Tile({ slot, period, offset }) {
  const [idx, setIdx] = useState(shown[slot]);
  useEffect(() => {
    let iv;
    const t0 = setTimeout(() => { setIdx(nextFor(slot)); iv = setInterval(() => setIdx(nextFor(slot)), period); }, offset);
    return () => { clearTimeout(t0); clearInterval(iv); };
  }, [slot, period, offset]);
  return (
    <div className="relative overflow-hidden bg-slate-900" data-testid={`live-tile-${slot}`}>
      {POOL.map((src, i) => <img key={src} src={src} alt="" className={`orbit-tile-img ${i === idx ? "is-on" : ""}`} />)}
      <div className="absolute bottom-1.5 left-1.5 text-[10px] font-mono text-white/90 bg-black/40 rounded px-1.5 py-0.5">{META[idx][0]} {META[idx][1]}</div>
    </div>
  );
}

export function LiveTiles({ className = "" }) {
  return (
    <div className={`grid grid-cols-2 gap-1 ${className}`} data-testid="live-tiles">
      <Tile slot={0} period={7000} offset={2500} />
      <Tile slot={1} period={8500} offset={5200} />
      <Tile slot={2} period={7600} offset={7900} />
      <Tile slot={3} period={9200} offset={10600} />
    </div>
  );
}
